import { render, staticRenderFns } from "./LogoInput2.vue?vue&type=template&id=65a8f6a1"
import script from "./LogoInput2.vue?vue&type=script&lang=js"
export * from "./LogoInput2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports